const MESES = [
    "ene", "feb", "mar", "abr", "may", "jun",
    "jul", "ago", "sep", "oct", "nov", "dic"
];

const moneda = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
});

export const arreglar = (v) => {
    if (typeof v !== "string" || !/[ÃÂ]/.test(v)) return v;

    try {
        return decodeURIComponent(escape(v));
    } catch (e) {
        return v;
    }
};

export const vacio = (v) =>
    v === null || v === undefined || String(v).trim() === "";

const parseFecha = (s) => {
    const m = String(s).match(
        /^(\d{4})-?(\d{2})-?(\d{2})(?:[ T](\d{2}):(\d{2}))?/
    );

    return m
        ? {
            a: m[1],
            m: +m[2],
            d: +m[3],
            h: m[4],
            mi: m[5],
        }
        : null;
};

const p2 = (n) => String(n).padStart(2, "0");

export const fFecha = (v) => {
    const f = parseFecha(v);

    if (!f) return v;

    return `${p2(f.d)}/${p2(f.m)}/${f.a}` +
        (f.h ? ` ${f.h}:${f.mi}` : "");
};

export const fRango = (v) => {
    const [a, b] = String(v).split("-").map((x) => x.trim());

    const fa = parseFecha(a);
    const fb = b && parseFecha(b);

    if (!fa) return v;

    const t = (f) => `${f.d} ${MESES[f.m - 1]}`;

    return fb
        ? `${t(fa)} – ${t(fb)} ${fb.a}`
        : `${t(fa)} ${fa.a}`;
};

const enmascararValor = (v, tipo, activo) => {
    const s = String(v);

    if (!activo) return s;

    if (tipo === "correo") {
        const [u, d] = s.split("@");

        return d ? `${u[0]}•••@${d}` : s;
    }

    return "••••" + s.slice(-4);
};

export const formatear = (v, tipo, mascara) => {
    v = arreglar(v);

    switch (tipo) {
        case "dinero":
            return isNaN(Number(v))
                ? v
                : moneda.format(Number(v));

        case "fecha":
            return fFecha(v);

        case "rango":
            return fRango(v);

        case "bool":
            return /^(s|si|sí|true|1)$/i.test(String(v))
                ? "Sí"
                : /^(n|no|false|0)$/i.test(String(v))
                    ? "No"
                    : v;

        case "mask":
        case "correo":
            return enmascararValor(v, tipo, mascara);

        default:
            return v;
    }
};

export const claseEstado = (txt) => {
    const t = String(txt || "").toLowerCase();

    if (
        /entregad|aprobad|confirmad|pagad/.test(t) &&
        !/pendiente/.test(t)
    ) {
        return "ok";
    }

    if (/pendiente|comprado|proceso/.test(t)) {
        return "";
    }

    return "neutro";
};

export const SECCIONES_B2C_PEDIDOS = [
    ["Pedido", [
        ["FECHA_PEDIDO", "Fecha pedido", "fecha"],
        ["ORDER_ID", "ID de orden"],
        ["TRAN_ID", "Id transacción"],
        ["SUB_ORDEN_ID", "Id de suborden"],
        ["ESTADO", "Estado e-commerce"],
        ["ESTADO_ENTREGA", "Estado entrega"],
        ["TIPO_DE_CLIENTE", "Compra como invitado", "bool"],
        ["FLUJO_DE_VENTA", "Flujo de venta"],
        ["TIENDA", "Tienda"],
        ["PREVENTA", "Preventa"],
    ]],

    ["Cliente", [
        ["NOMBRE", "Nombre"],
        ["APELLIDO", "Apellido"],
        ["CORREO_ELECTRONICO", "Correo electrónico", "correo"],
        ["TELEFONO", "Teléfono", "mask"],
        ["IDENTIFICACION_DE_CLIENTE", "Identificación", "mask"],
        ["SEGMENTO", "Segmento"],
    ]],

    ["Envío", [
        ["DEPARTAMENTO", "Departamento"],
        ["CIUDAD", "Ciudad"],
        ["BARRIO", "Barrio"],
        ["DIRECCION", "Dirección"],
        ["DIRECCION_CUENTA_HOGAR", "Dirección cuenta hogar"],
        ["TIPO_DE_INMUEBLE", "Tipo de inmueble"],
        ["BLOQUE", "Bloque o interior"],
        ["INFORMACION_ADICIONAL", "Información adicional"],
        ["QUIEN_RECIBE", "Quién recibe"],
        ["FORMA_ENTREGA", "Forma de entrega"],
        ["NOMBRE_PROMESA_ENTREGA", "Promesa de entrega"],
        ["FECHA_PROMESA_ENTREGA", "Fecha promesa", "rango"],
        ["VALOR_NETO_ENVIO", "Valor neto envío", "dinero"],
        ["IVA_ENVIO", "IVA envío", "dinero"],
        ["TOTAL_ENVIO", "Total envío", "dinero"],
    ]],

    ["Producto", [
        ["CODIGO_MATERIAL", "Código de material"],
        ["SKU_PADRE", "SKU padre"],
        ["NOMBRE_MATERIAL", "Nombre del material"],
        ["CANTIDAD_MATERIAL", "Cantidad"],
        ["CATEGORIA", "Categoría"],
        ["SUBCATEGORIA_DE_PRODUCTO", "Subcategoría"],
        ["CODIGO_GTIN", "Código GTIN"],
        ["GARANTIA", "Garantía"],
        ["CATEGORIA_HOGARES", "Categoría (Hogares)"],
        ["SUBCATEGORIA_DE_PRODUCTO_HOGARES", "Subcategoría (Hogares)"],
        ["NOMBRE_DEL_MATERIAL", "Nombre material (Hogares)"],
    ]],

    ["Pago", [
        ["ESTADO_PAGO", "Estado del pago"],
        ["METODO_DE_PAGO", "Método de pago"],
        ["FRANQUICIA", "Franquicia"],
        ["NUMERO_TARJETA_CREDITO", "N.º de tarjeta", "mask"],
        ["NUMERO_APROBACION_PAGO", "N.º de aprobación"],
        ["NUMERO_TRAZABILIDAD", "N.º de trazabilidad"],
        ["VALOR_RECAUDADO", "Valor recaudado", "dinero"],
        ["IMPUESTO_DE_LA_ORDEN", "Impuestos de la orden", "dinero"],
        ["CODIGO_CUPON", "Código de cupón"],
        ["DESCUENTO_CUPON", "Descuento cupón", "dinero"],
        ["DOMICILIO", "Domicilio"],
    ]],

    ["Financiación", [
        ["CANTIDAD_DE_CUOTAS", "Cantidad de cuotas"],
        ["CUENTA_PAGO_CUOTAS", "Cuenta pago a cuotas", "mask"],
        ["SALDO_FINANCIADO", "Saldo financiado", "dinero"],
        ["MONTO_CUOTA_INICIAL", "Monto cuota inicial", "dinero"],
        ["METODO_CUOTA_INICIAL", "Método cuota inicial"],
    ]],

    ["Entrega y otros", [
        ["FECHA_ESTIMADA_ENTREGA", "Fecha estimada entrega", "fecha"],
        ["FECHA_REAL_ENTREGA", "Fecha real entrega", "fecha"],
        ["FECHA_DE_VENTANA_DE_CAMBIO", "Ventana de cambio", "fecha"],
        ["NUMERO_DE_PIN", "Número de PIN"],
        ["FECHA_DE_VENCIMIENTO_PIN", "Vencimiento PIN", "fecha"],
        ["OT", "OT"],
        ["MIN_A_PORTAR", "MIN a portar"],
        ["LINEA_A_MIGRAR", "Línea a migrar"],
        ["CODIGO_VENDEDOR", "Código de vendedor"],
        ["CODIGO_CAMPANIA", "Código campaña"],
        ["ID_RESERVE_POLIEDRO", "Id reserve Poliedro"],
        ["IP_ORIGEN", "IP origen"],
        ["MENSAJE_ERROR", "Mensaje de error"],
    ]],
];

export const SECCIONES_B2B_PEDIDOS = [
    ["Pedido", [
        ["FECHA_PEDIDO", "Fecha pedido", "fecha"],
        ["PEDIDO_SAP", "Pedido SAP"],
        ["ID_TRANSACCION", "Id transacción"],
        ["NUM_DOC", "N.º documento"],
        ["ESTADO_COMMERCE", "Estado e-commerce"],
        ["ESTADO_ENTREGA", "Estado entrega"],
        ["FLUJO_VENTA", "Flujo de venta"],
        ["TIENDA", "Tienda"],
        ["INFO_ADICIONAL", "Información adicional"],
        ["IP_ORIGEN", "IP origen"],
        ["MENSAJE_ERROR", "Mensaje de error"],
    ]],

    ["Cliente", [
        ["NOMBRE", "Nombre"],
        ["APELLIDO", "Apellido"],
        ["CORREO", "Correo electrónico", "correo"],
        ["TELEFONO", "Teléfono", "mask"],
        ["NUM_DOC", "Número documento", "mask"],
        ["SEGMENTO", "Segmento"],
    ]],

    ["Envío", [
        ["DEPARTAMENTO", "Departamento"],
        ["CIUDAD", "Ciudad"],
        ["BARRIO", "Barrio"],
        ["DIRECCION", "Dirección"],
        ["TIPO_INMUEBLE", "Tipo de inmueble"],
        ["BLOQUE_O_INTERIOR", "Bloque o interior"],
        ["INFO_ADICIONAL", "Información adicional"],
        ["QUIEN_RECIBE", "Quién recibe"],
        ["FORMA_ENTREGA", "Forma de entrega"],
        ["FECHA_ESTIMADA_ENTREGA", "Fecha estimada entrega", "fecha"],
        ["COSTO_NETO", "Costo neto envío", "dinero"],
        ["IVA_ENVIO", "IVA envío", "dinero"],
        ["TOTAL_ENVIO", "Total envío", "dinero"],
    ]],

    ["Producto", [
        ["COD_MATERIAL", "Código de material"],
        ["SKU_PADRE", "SKU padre"],
        ["NOMBRE_MATERIAL", "Nombre del material"],
        ["CANT_MATERIAL", "Cantidad"],
        ["CATEGORIA", "Categoría"],
        ["SUBCATEGORIA", "Subcategoría"],
        ["COD_GTIN", "Código GTIN"],
        ["GARANTIA", "Garantía"],
    ]],

    ["Pago", [
        ["ESTADO_PAGO", "Estado del pago"],
        ["METODO_PAGO", "Método de pago"],
        ["FRANQUICIA", "Franquicia"],
        ["NUM_TARJETA", "N.º de tarjeta", "mask"],
        ["NUM_APRUEBA", "N.º de aprobación"],
        ["NUM_TRAZA", "N.º de trazabilidad"],
        ["VALOR_RECAUDADO", "Valor recaudado", "dinero"],
        ["IMPUESTO_ORDEN", "Impuestos de la orden", "dinero"],
        ["COD_CUPON", "Código de cupón"],
        ["DESC_CUPON", "Descuento cupón", "dinero"],
        ["DESCUENTO", "Descuento", "dinero"],
    ]],

    ["Financiación", [
        ["CANT_CUOTAS", "Cantidad de cuotas"],
        ["PAGO_CUOTAS", "Pago de cuotas"],
    ]],
];

export const SECCIONES_B2C_PRODUCTOS = [
    ["Producto", [
        ["NOMBRE_EQUIPO", "Nombre equipo"],
        ["SKU", "SKU"],
        ["SKU_PADRE", "SKU padre"],
        ["COLOR", "Color"],
        ["CODIGO_GTIN", "Código GTIN"],
        ["ESTADO", "Estado"],
        ["CATEGORIA", "Categoría"],
        ["SUBCATEGORIA", "Subcategoría"],
        ["STOCK_DISPONIBLE", "Stock disponible"],
        ["GARANTIA", "Garantía"],
    ]],

    ["Información comercial", [
        ["NOMBRE_SELLER", "Nombre del seller"],
        ["FABRICANTE", "Fabricante"],
        ["TERMINOS_Y_CONDICIONES", "Términos y condiciones"],
        ["PRECIO_NORMAL", "Precio normal", "dinero"],
        ["PRECIO_OFERTA", "Precio de oferta", "dinero"],
    ]],

    ["Imágenes y enlaces", [
        ["URL_IMAGEN_CATALOGO", "URL imagen catálogo"],
        ["URL_IMAGEN_CLAROSHOP", "URL imagen Claroshop"],
        ["URL_CORTA_PRODUCTO", "URL corta del producto"],
        ["DESCRIPCION_COMPLETA", "Descripción completa"],
    ]],
];
